import React from 'react';

export const currentUser = {
  authenticated: false,
  mobileNumberProvided: false,
  evoucherNo: '',
  evoucherStatus: '',
  memberId: '',
  coverage: '',
  link: '',
  termsAndConditionId: '',
  loa_no: ''
};

export default React.createContext({
  ...currentUser,
});
